import { Either } from 'monet';

/**
 * @description Шлюз аутентификации.
 * @param {Axios} axios HTTP клиент.
 * @constructor
 */
export default function AuthGateway(axios) {
  /**
   * @description Создать пароль.
   * @param {string} to       Адрес приема.
   * @param {string} password Новый пароль.
   */
  this.resetPassword = async (to, password) => {
    try {
      const response = await axios.post(to, { password });
      return Either.right(response.data);
    } catch (error) {
      if (error.isAxiosError && error.response.status === 400) {
        return Either.left(error.response.data);
      }
      if (error.isAxiosError) {
        return Either.left({ message: 'Произошла непредвиденная ошибка' });
      }
      throw error;
    }
  };

  /**
   * @description Отправить письмо восстановления пароля.
   * @param {string} emailAddress Адрес электронной почты.
   * @returns {Promise<Either>}
   */
  this.sendPasswordRecoveryEmail = async (emailAddress) => {
    const params = { email_address: emailAddress };
    try {
      const response = await axios.post('/api/password-recovery', params);
      return Either.right(response.data);
    } catch (error) {
      if (error.isAxiosError && error.response.status === 400) {
        return Either.left(error.response.data);
      }
      if (error.isAxiosError && error.response.status === 404) {
        return Either.left(error.response.data);
      }
      if (error.isAxiosError) {
        return Either.left({ message: 'Произошла непредвиденная ошибка' });
      }
      throw error;
    }
  };
  /**
   * @description Отправить новое письмо подтверждения адреса электронной почты.
   * @param {string} email Идентификатор клиники.
   * @returns {Promise<Either>}
   */
  this.resendActivationEmail = async (email) => {
    const params = { email };
    try {
      const response = await axios.post('/api/email/verify/resend', params);
      return Either.right(response.data);
    } catch (error) {
      if (error.isAxiosError) {
        if (error.response.status === 400 || error.response.status === 429) {
          return Either.left(error.response.data);
        }
        return Either.left({ message: 'Произошла непредвиденная ошибка' });
      }
      throw error;
    }
  };
}
